module.exports = __webpack_public_path__ + "img/CTABlade.9f88ea1.png";